/**
 * Capitalizes the first letter of selected string fields on a payload
 * before POST / PUT create-update API calls.
 *
 * Usage:
 *   const payload = capitalizeTheStartingCharacterFilter(data, ["firstName", "lastName", "city"]);
 *   await AxiosInstance().post("/patients", payload);
 */
export function capitalizeTheStartingCharacterFilter<T extends Record<string, any>>(
  payload: T,
  fields: string[],
): T {
  if (!payload || typeof payload !== "object" || Array.isArray(payload)) {
    return payload;
  }

  const next : Record<string, any> = { ...payload };

  for (const field of fields) {
    const value = next[field];
    if (typeof value !== "string") continue;

    const trimmed =  value.trim();
    if (!trimmed) {
      next[field] = trimmed;
      continue;
    }

    next[field] = trimmed.charAt(0).toUpperCase() + trimmed.slice(1);
  }

  return next as T;
}

/** Common person / address fields to capitalize on create & update payloads. */
export const PERSON_CAPITALIZE_FIELDS = [
  "firstName",
  "middleName",
  "lastName",
  // "primaryInsuranceName",
  // "secondaryInsuranceName",
];

/** Organization / facility name and address fields. */
export const ORGANIZATION_CAPITALIZE_FIELDS = [
  "name",
  "pocName",
  "billingName",
  "billerName",
];
